/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLModalService } from 'ml-portals-services-react';
import { QuestionSetComponent, platformMessages } from 'ml-components-platform-react';
import { MLModifierComponent } from 'ml-components-common-react';
import { MLHVQDiscrepancyPropertyColomnComponent } from 'gw-capability-quoteandbind-pa-react';
import {MLPortalSettingsService} from 'gw-capability-quoteandbind';

import metadata from './MLCRAdditionalInformationComponent.metadata.json5';
import messages from './MLCRAdditionalInformationComponent.messages';
import styles from './MLCRAdditionalInformationComponent.module.scss';
import moment from 'moment';

import {MLNotificationBlockUtil} from 'ml-portals-util-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLPortalStorageService } from 'ml-services-common-react';
const PA_MODIFIER_PATH = 'lobData.personalAuto.modifiers_ML';
const LINE_MODIFIERS_PATH = 'lobData.personalAuto.modifiers_ML.lineModifiers';
const multipolicyLobCodes = ['PAMultiplePolicyHomePolicyNumber_ML', 'PAMultiplePolicyRentersPolicyNumber_ML', 'PAMultiplePolicyCondoPolicyNumber_ML', 'PAMultiplePolicyMobilePolicyNumber_ML',
    'PAMultiplePolicyLandlordPolicyNumber_ML','PAMultiplePolicyLandlordCondoPolicyNumber_ML', 'PAMultiplePolicyBoatPolicyNumber_ML', 'PAMultiplePolicyUmbrellaPolicyNumber_ML',
    'PAMulitplePolicyMotorCyclePolicyNumber_Ext', 'PAMulitplePolicyRecreationalVehPolicyNumber_Ext', 'PAMulitplePolicyOffRoadVehPolicyNumber_Ext']

function MLCRAdditionalInformationComponent(props) {

    const {
        submissionVM,
        updateWizardData,
        onValidate,
        showValidationErrors,
        onUpdateEmail,
        showInvalidEmailError,
        checkEmail,
        isInitialPageLoadCompleted,
        setIsInitialPageLoadCompleted
    } = props;

    const { LoadSaveService } = useDependencies('LoadSaveService');
    const viewModelService = useContext(ViewModelServiceContext);
    const { showProgressDialog,hideProgressDialog } = MLModalService();
    const translator = useTranslator();
    const {
        addWarningAlert,
        addErrorAlert,
        clearBlockAlerts,
        clearErrorAlerts
    } = MLNotificationBlockUtil();

    const { authHeader } = useAuthentication();
    const [inSync, setInSync] = useState(false);
    const [pageAlreadyVisited, setPageAlreadyVisited] = useState(false);
    const [invalidEmailErrorMessage, setInvalidEmailErrorMessage] = useState([]);
    const [farmersPrivacyNoticeValue, setFarmersPrivacyNoticeValue] = useState(_.get(submissionVM, 'lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext'));
    const [isMVRCacheQuestionVisible, setIsMVRCacheQuestionVisible] = useState(false);
    const ML_STORAGE_KEY_ALREADY_VISITED = "USER_ALREADY_VISITED"
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);

    // Modifiers
    const lineModifiers = _.get(submissionVM, LINE_MODIFIERS_PATH);
    const paModifiers = _.get(submissionVM, PA_MODIFIER_PATH);

    // DE212091 - update the modifier to make sure the validation will be  
    // triggered when there has defaulted value from CP bridged Quote
    if (lineModifiers.value) {
        lineModifiers.value.forEach(
            (mod) => {
                mod.savedFromPortal = true;
                mod.updated = true;
                mod.editMode_ML = true;

                if (multipolicyLobCodes.includes(mod.codeIdentifier_ML)) {
                    mod.isVisible_ML = false
                    mod.isInputValueRequired_ML = false
                    mod.editMode_ML = false
                    mod.savedFromPortal = false
                } else {
                    mod.isVisible_ML = true
                }
            }
        );
    }

    const showFarmersPrivacyNoticerValue = () => {
        return submissionVM.baseData.productCode.value === "PersonalAuto";
    }

    const updateFarmersPrivacyNotice = useCallback((newValue) => {
        const flag = newValue;
        setFarmersPrivacyNoticeValue(flag);
        _.set(submissionVM, 'lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext', flag)
        updateWizardData(submissionVM);
    }, []);

    useEffect(() => {
      if(showFarmersPrivacyNoticerValue() && submissionVM.quoteID.value && !isInitialPageLoadCompleted){
            const storagePromise = MLPortalStorageService.retrieve(submissionVM.quoteID.value, null, ML_STORAGE_KEY_ALREADY_VISITED, authHeader);
            showProgressDialog(platformMessages.synchronizingQuote, storagePromise);
            storagePromise.then((response) => {
                
                if (typeof response === 'string') {
                    let parsedResponse
                    try{
                        parsedResponse = JSON.parse(response);
                        if (parsedResponse.hasOwnProperty('alreadyVisited') && parsedResponse.alreadyVisited === true) {
                            setPageAlreadyVisited(true);
                        }
                    }catch(e){
                        console.log(e)
                    }
                }
            })
        }

        setIsInitialPageLoadCompleted(true);

    }, [])

    useEffect(() => {
      MLPortalSettingsService.getSettings(authHeader).then((response) => {
        if (response) {
          /*
            DE277404
          */
         let mvrCacheEnabledDate = response.isMVRCacheEnabled
         /*
         if we have createTime then we know its an existing submission
         else we treat it a new submission and use current date
         */
          const createTime = submissionVM.createTime.value;
          if (createTime) {
            let enabledCache = moment(createTime).startOf('day').isSameOrAfter(moment(mvrCacheEnabledDate).startOf('day'));
            setIsMVRCacheQuestionVisible(enabledCache);
          }
          else {
            let createDate = new Date();
            let enabledCache = moment(createDate).startOf('day').isSameOrAfter(moment(mvrCacheEnabledDate).startOf('day'));
            setIsMVRCacheQuestionVisible(enabledCache);
          }
        }
      });
    }, [authHeader]);
    

    const isModifierTypeDate = (mod) => mod.valueType.value === 'date' && mod.dateValue_ML;

    const isModifierTypeTypeKey = (mod) => mod.valueType.value === 'TypeKeyAsText';

    const isDateModifierPeriodValid = (mod) => mod.dateValue_ML.year.value >= 1900 && mod.dateValue_ML.year.value < 2100
            && mod.dateValue_ML.aspects && mod.dateValue_ML.aspects.valid;

    const checkOwnsResidenceModifier = (mod, copiedView) => {
        if (mod.patternCode.value === 'z70hmvhmucbde2eo899j9kmgjdb') {
            if (mod.chosenTermValue.value) {
                if (!copiedView.lobData.personalAuto.modifiers_ML.yearsAtCurrentResidence) {
                    copiedView.lobData.personalAuto.modifiers_ML.yearsAtCurrentResidence = 0;
                }
            }
        }
    };

    const syncModifierDependentQuestions = (submissionData, mlModifier) => {
        if (mlModifier.yearsAtCurrentResidence) {
            mlModifier.yearsAtCurrentResidence.value = submissionData.yearsAtCurrentResidence;
        }
    };

    const updateAndSyncModifier = (mod, modal) => {
        _.set(mod, 'updated.value', true);
        const validLineMods = [];
        let copiedModel = viewModelService.clone(submissionVM);

        const setEditMode = (editMode) => {
            copiedModel.value.lobData.personalAuto.coverables.drivers.forEach((driver) => {
                driver.editMode_ML = editMode;
            });
            copiedModel.value.lobData.personalAuto.coverables.vehicles.forEach((vehicle) => {
                vehicle.editMode_ML = editMode;
            });

            copiedModel.value.lobData.personalAuto.modifiers_ML.lineModifiers.forEach((lineModifier) => {
                lineModifier.editMode_ML = editMode;
            });
        };

        const syncDrivers = (data) => {
            const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.children', []);
            const hasNewDrivers = drivers.some((driver) => {
                return !!driver.tempID.value && !driver.publicID.value;
            })

            if (hasNewDrivers) {
                _.set(submissionVM, 'value.lobData.personalAuto.coverables.drivers', _.get(data, 'lobData.personalAuto.coverables.drivers'));
            }

            console.log('log');

            
        };;

        setEditMode(false);

        // Need to disable the driver modifiers validity check when syncing addtional information modifiers to avoid the modifiers update failed
        // due to the driver modifier has dependent questions is required to answer but default with blank value through CR bridging.
        // The reason why this is not needed in the normal flow because the driver modifiers/vehicle modifiers are answered in a different step than
        // the additional info modifiers, so they won't interfere with each other and user won't have the chance to leave the page without
        // the required questions are not answered. But in CR flow, all three set of modifiers are brought together in a single page which will interfere 
        // each other when sync if required questions is not answered, the sync will failed but the error will be swallowed and in UI it looks like a success.
        // When CR quote bridging some depandent questions are set to true and was defaulted with blank value, so we need to bypass those fields and let PC
        // to sync with the modifiers that only happen to update.
        copiedModel?.value?.lobData?.personalAuto?.coverables?.drivers?.forEach((driver) => {
            if (!_.isEmpty(driver.driverModifiers_ML)) {
                driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                    if (modifier.isDependentModifier_ML) {
                        modifier.editMode_ML = false;
                    }
                });
            }
        });

        for (let i = 0; i < lineModifiers.children.length; i += 1) {
            const modifier = lineModifiers.children[i];
            checkOwnsResidenceModifier(modifier, copiedModel);
            if (modifier.aspects.subtreeValid) {
                validLineMods.push(modifier.value);
            }
        }
        _.set(copiedModel, LINE_MODIFIERS_PATH, validLineMods);
        _.set(copiedModel, 'bypassValidationForComprater_Ext', true);

        if (!inSync) {
            // "updateModifiers" was called multiple times so that it has caused CDCE error.
            // Here it controls to make sure to call one at a time
            const submissionLoadPromise = LoadSaveService.updateModifiers(copiedModel.value, authHeader);

            setInSync(true);

            if (modal) {
                setTimeout(() => {
                    showProgressDialog(platformMessages.syncingDiscounts, submissionLoadPromise, true);
                }, 100);
            }

            submissionLoadPromise.then((submissionData) => {
                syncModifiers(submissionData.lobData.personalAuto.modifiers_ML.lineModifiers, lineModifiers);
                syncModifierDependentQuestions(submissionData.lobData.personalAuto.modifiers_ML, paModifiers);

                // if new drivers were added, need to resync with submission
                syncDrivers(submissionData)

                updateWizardData(submissionVM);
            }, (error) => {
                // eslint-disable-next-line no-console
                console.error(error);

            }).finally(() => {
                setEditMode(true)
                setInSync(false);
            });
        }
    };

    const syncModifiers = (submissionData, mlModifier) => {
        submissionData.forEach((mod) => {
            const oldMod = mlModifier.value.find((value) => value.patternCode === mod.patternCode);
            _.set(mod, 'chosenTermValue', oldMod ? oldMod.chosenTermValue : null);
            if (mod.valueType === 'boolean') {
                _.set(mod, 'chosenTermValue', oldMod ? oldMod.chosenTermValue : false);
            }
            if (!multipolicyLobCodes.includes(mod.codeIdentifier_ML)) {
                _.set(mod, 'savedFromPortal', true);
                _.set(mod, 'editMode_ML', true);
            }
        });
        _.set(mlModifier, 'value', submissionData);
    };

    const updateModifier = (mod, modal = true) => {
        if (isModifierTypeDate(mod)) {
            if (isDateModifierPeriodValid(mod)) {
                updateAndSyncModifier(mod, modal);
            }
        } else if (!isModifierTypeTypeKey(mod)) {
                updateAndSyncModifier(mod, modal);
        }
        else if(isModernProduct && submissionVM.baseData.productCode.value === "PersonalAuto"){
            updateAndSyncModifier(mod, modal);
        }
    };

    // Email
    const onEmailUpdate = (value) => {
        _.set(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value', value);
        updateWizardData(submissionVM);
        onUpdateEmail(value)
    }

    // AdditionalInformation Question Set
    const questionSets = submissionVM.lobData.personalAuto.questionSets_ML.value;
    const quoteID = submissionVM.quoteID.value;
    let questionSetSyncing = false;
    const syncQuestionSets = (aQuestionSetAnswersValue) => {
        if (questionSets && !questionSetSyncing) {

            const newVm = viewModelService.clone(submissionVM);
            const { code, answers } = aQuestionSetAnswersValue;
            const questionSetAnswers = Object.keys(answers)

            // To Check if anyOther questions are getting under HouseAdditionalInformation
            if (code && code === "PAHouseAdditionalInformation_ML" &&
                questionSetAnswers && questionSetAnswers.length === 1 &&
                questionSetAnswers[0] === "PAHighestLevelOfEducation_ML") {

                _.set(newVm, 'lobData.personalAuto.questionSets_ML.houseAdditionalInformation.value', aQuestionSetAnswersValue);
                updateWizardData(newVm);
            }
            else {
                questionSetSyncing = true;

                const syncPromise = LoadSaveService.syncQuestionSetML(quoteID, [aQuestionSetAnswersValue], authHeader);

                setTimeout(() => {
                    showProgressDialog(platformMessages.syncing, syncPromise, true);
                }, 100);
                syncPromise.then((updatedQuestions) => {

                    const transformedQuestions = {};

                    updatedQuestions.forEach((q) => { transformedQuestions[q.code] = q; });
                    _.set(newVm, 'lobData.personalAuto.questionSets_ML.preQualification.value', transformedQuestions.PAPersonalAutoPreQual);
                    _.set(newVm, 'lobData.personalAuto.questionSets_ML.priorInsurance.value', transformedQuestions.PAPriorInsurance_ML);
                    _.set(newVm, 'lobData.personalAuto.questionSets_ML.houseAdditionalInformation.value', transformedQuestions.PAHouseAdditionalInformation_ML);
                    updateWizardData(newVm);
                }).finally(() => {
                    questionSetSyncing = false;
                });
            }

        }
    };

    useEffect(() => {
        if(showInvalidEmailError && _.isEmpty(invalidEmailErrorMessage)){
            setInvalidEmailErrorMessage([translator(messages.verifyEmail)])
        }else{
            setInvalidEmailErrorMessage([])
        }
    }, [showInvalidEmailError])
    


    // Viewmodel form
    const overrideProps = {
        NonDiscrepancyProperty: {
            modifier: lineModifiers,
            onValidate: onValidate,
            updateModifier,
            isHomeowners: false,
            isCompRaterSpacing: true,
            isCompRaterFilterModifiers: true,
            showValidationErrors
        },
        Houseadditionalquestionset: {
            showHeaderML: false,
            labelPosition: 'top',
            value: _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.houseAdditionalInformation.value'),
            model: submissionVM,
            onValidate: onValidate,
            onValueChange: syncQuestionSets
        },
        Email:{
            value: _.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value'),
            onValueChange: onEmailUpdate,
            onBlur:checkEmail,
            validationMessages : invalidEmailErrorMessage,
            model: submissionVM,
            onValidate: onValidate
        },
        emailScriptContainer: {
            visible: false
        },
        farmersPrivacyNoticeContainer: {
            visible: isMVRCacheQuestionVisible && showFarmersPrivacyNoticerValue()
        },
        farmersPrivacyNoticeRadioButton: {
            visible: isMVRCacheQuestionVisible && showFarmersPrivacyNoticerValue(),
            onValueChange: updateFarmersPrivacyNotice,
            value: farmersPrivacyNoticeValue,
            disabled: pageAlreadyVisited
        },
    }

    const resolvers = {
        resolveComponentMap: {
            discrepancyPropertyComponent: MLHVQDiscrepancyPropertyColomnComponent,
            modifierComponent: MLModifierComponent,
            questionset: QuestionSetComponent,
        },
        resolveCallbackMap: {
            onValidate: onValidate,
        },
        resolveClassNameMap: styles
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            onValidationChange={onValidate}
            showErrors={showValidationErrors}
        />
    );
}

MLCRAdditionalInformationComponent.propTypes = {

};
MLCRAdditionalInformationComponent.defaultProps = {

};
export default withRouter(MLCRAdditionalInformationComponent);
